import React from 'react';
import { SERVICES } from '../../data/site';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';

// SEO (Aug 30): the h2 stays the brand line. The keyword-bearing terms live in
// the description and the coverage line under the grid, so the section carries
// 'stage production', 'lighting', 'sound' and the market names in real copy.
// Do NOT add gear model numbers here until FAR's actual inventory is documented
// (it is the biggest differentiator available, and it must not be invented).

export function Stage() {
  return <section id="stage" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-338" data-mp="3awagsdb5i7ht">
      <SectionHeading eyebrow="EVENT PRODUCTION" title={<>
            We build the <span className="text-gradient" data-id="element-340" data-mp="3pnjc931qin2v">whole show</span>
          </>} description="Stage production, lighting and sound across the Gulf Coast. From the deck up: structure, light, sound, screens and the crew that calls it." data-id="element-339" data-mp="3kogg683qfr71" />

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-341" data-mp="2mhb874hc01i">
        {SERVICES.map((service, i) => <Reveal key={service.title} delay={i * 0.06} className={i === 0 ? 'h-full lg:col-span-2' : 'h-full'} data-id="element-342" data-mp="3tqo4ha8gzhna" data-mpi={i}>
            <article className="glass group flex h-full flex-col rounded-2xl p-6 transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-1.5 hover:border-cyan/50 hover:shadow-neon-cyan" data-id="element-343" data-mp="3ks2qzthuustd">
              <span className="font-tech text-[0.65rem] tracking-[0.3em] text-cyan/70" data-id="element-344" data-mp="gedz1yz47ns3">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 font-display text-[0.78rem] tracking-[0.1em] text-white sm:text-sm" data-id="element-345" data-mp="7l0ycaut7hvg">
                {service.title.toUpperCase()}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-346" data-mp="144rulzgws4rf">{service.detail}</p>
            </article>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-347" data-mp="2tjj1wm9ls967">
        <p className="mt-7 text-center text-sm leading-relaxed text-white/45" data-id="element-348" data-mp="2tkawpuvdm2vf">
          Serving <span className="text-white/70" data-id="element-349" data-mp="2yhkkz77148ho">Gulf Shores</span>,{' '}
          <span className="text-white/70" data-id="element-350" data-mp="2juj0yxbjj3pd">Orange Beach</span>,{' '}
          <span className="text-white/70" data-id="element-351" data-mp="2jrwr2r16gc3z">Foley</span>,{' '}
          <span className="text-white/70" data-id="element-352" data-mp="2orrkp2cc7fsq">Pensacola</span>,{' '}
          <span className="text-white/70" data-id="element-353" data-mp="2atksa1q5q80g">Mobile, Alabama</span> and{' '}
          <span className="text-white/70" data-id="element-354" data-mp="2ave03kciaya1">Destin</span>. Building stages on this coast since 2015.
        </p>
      </Reveal>
    </section>;
}